import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Collapse, TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../icons/OnEditIcon';
import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { loadParticipantByPtCode } from '../../../store/participantService';
import ValidationRowDetails from '../../claims/validation/ValidationRowDetails';

import table from '../../../commonStyles/tables.module.css';
import local from './claims.module.css';

const ClaimTableRow = ({ row, roles, acceptedRoles, toggleDropdown, openId, onEditAction }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [open, setOpen] = useState(null);
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    useEffect(() => {
        if (isPTRequestSent && currentParticipant.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    const onClickPTCode = () => {
        if (!row?.ptCode) return;
        dispatch(loadParticipantByPtCode(row.ptCode));
        setIsPTRequestSent(true);
    };

    // RENDER
    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={`${table.tableRowStripes} ${table.oldLace} ${table.canOpen}`}>
                <TableCell className={local.claimsCodeLink} onClick={onClickPTCode}>
                    <span className={table.rowLink}>{row?.ptCode}</span>
                </TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {row?.firstName === 'zz' ? '-' : row.firstName}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {row?.lastName === 'zz' ? '-' : row.lastName}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {row?.eventName === 'zz' ? '-' : row.eventName}
                </TableCell>

                {row?.onUpdateStatus ? (
                    <TableCell className={local.claimsCodeLink} onClick={row.onUpdateStatus}>
                        <span className={local.claimsCodeLink}>{row?.statusName}</span>
                    </TableCell>
                ) : (
                    <TableCell onClick={onToggleDropdown}>
                        {row?.statusName === 'zz' ? '-' : row.statusName}
                    </TableCell>
                )}

                <TableCell align="center" onClick={onToggleDropdown}>
                    {row?.actionStatus === 'zz' ? '-' : row.actionStatus}
                </TableCell>
                <TableCell className={local.editCell}>
                    {row?.actionStatus === 'Corrective Action Required' ? (
                        <OnEditIcon
                            onEdit={() => onEditAction(row)}
                            roles={roles}
                            acceptedRoles={acceptedRoles}
                        />
                    ) : null}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={7} sx={{ padding: '0', border: 'none' }}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <ValidationRowDetails row={row} onClose={() => setOpen(null)} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

ClaimTableRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string,
    onEditAction: PropTypes.func
};

export default ClaimTableRow;
